webpackJsonp([263791100135453],{

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nicolebio2.f5daa9b5.jpg";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nicolebio = __webpack_require__(488);
	
	var _nicolebio2 = _interopRequireDefault(_nicolebio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'About Nicole'
	    ),
	    _react2.default.createElement('img', {
	      className: 'portrait',
	      src: _nicolebio2.default,
	      alt: 'portrait'
	    }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Nicole received her master\u2019s degree from the Seattle Institute of Oriental Medicine(SIOM). She is trained in traditional Chinese acupuncture, Japanese acupuncture, Chinese herbal medicine, Chinese nutritional therapy, Auricular (ear) acupuncture, Tui Na (Chinese medical massage), Qi Gong (movement therapy), Chinese medical language and detox acupuncture for the treatment of addictions. Prior to becoming an acupuncturist, Nicole received her BA in Sociology and Peace and Conflict Studies from Brandeis University. She spent several years working in the non-profit healthcare field, and has worked with children and adults with physical and learning disabilities as a personal care assistant and teacher.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Certifications:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Masters degree in Acupuncture and Oriental Medicine (MAcOM)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Diplomate in Oriental Medicine (Acupuncture and Chinese Herbal Medicine) from the National Certification Commission for Acupuncture and Oriental Medicine (NCCAOM)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'National Association for Detox Acupuncture (NADA) certification for the treatment of addictions'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Licensed East Asian Medicine Practitioner (EAMP) in Washington State: Licensed to practice acupuncture and East Asian Medicine'
	      )
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-7c34c0c9ee2cc9580636.js